import React, { useEffect, useRef, useState } from "react";
import { Eye, EyeOff } from "feather-icons-react/build/IconComponents";
import axios from "axios";
import { baseURl } from "../../../utils/urls";
import useToast from "../../../hooks/userToast";
import Sidebar from "../../Sidebar";
import DoctorHeader from "../../../doctor/DoctorHeader";
import {
  Button,
  Modal,
  Form,
  Input,
  Select,
  InputNumber,
  Upload,
  message,
} from "antd";
import SignatureCrop from "./SignatureCrop/SignatureCrop";
import { getRoleName } from "../../../utils/roles";
import { useNavigate } from "react-router-dom";
import useUser from "../../../hooks/useUser";
import { CloseOutlined, UploadOutlined } from "@ant-design/icons";
import { capitalizeEachWord } from "../../../utils/capitalize";

const { Option } = Select;

const Signup = () => {
  const [roles, setRoles] = useState();
  const [categories, setCategories] = useState();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordVisible1, setPasswordVisible1] = useState(false);
  const { toastSuccess, toastError } = useToast();
  const { userToken, isSubAdmin } = useUser();
  const fileInputRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [finalImage, setFinalImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [signature, setSignature] = useState();
  const [form] = Form.useForm();

  const selectedRole = Form.useWatch("role", form);
  // const certificatenumber = Form.useWatch("certificatenumber", form);
  // const filename = Form.useWatch("filename", form);
  const digitalSignature = Form.useWatch("digitalSignature", form) || [];

  useEffect(() => {
    fetchRoles();
    fetchCategories();
  }, []);
  useEffect(() => {
    if (isSubAdmin) {
      form.setFieldsValue({ role: "subadmin" });
    }
  }, [isSubAdmin, roles]);

  function dataURLToFile(dataURL, filename) {
    const [header, base64Data] = dataURL.split(",");
    const mime = header.match(/:(.*?);/)[1];
    const binaryString = atob(base64Data);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([bytes], { type: mime });
    return new File([blob], filename, { type: mime, lastModified: Date.now() });
  }

  const onFinish = async (data) => {
    setLoading(true);
    if (
      selectedRole !== "subadmin" &&
      (!data?.categoryId || data?.categoryId === "Select Category")
    ) {
      form.setFields([
        { name: "categoryId", errors: ["Category is required"] },
      ]);
      setLoading(false);
      return;
    }
    if (selectedRole === "radiologist" && !finalImage) {
      if (!data.filename)
        form.setFields([
          { name: "filename", errors: ["Filename is required"] },
        ]);
      if (!finalImage)
        form.setFields([
          {
            name: "digitalSignature",
            errors: ["Digital signature is required"],
          },
        ]);
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("name", `${data?.firstName} ${data?.lastName}`);
    formData.append("contact_no", data?.phone);
    formData.append("address", data?.address);
    formData.append("email", data?.email);
    if (data?.header?.file) {
      formData.append("site_report_header", data?.header?.file);
    }
    if (data?.footer?.file) {
      formData.append("site_report_footer", data?.footer?.file);
    }
    formData.append(
      "categoryId",
      isSubAdmin || selectedRole === "subadmin"
        ? parseInt(categories.filter((elem) => elem.name === "excellent")[0].id)
        : data?.categoryId
    );
    formData.append("roleName", data?.role);
    formData.append("password", data?.password);
    formData.append("age", data?.age);
    formData.append("gender", data?.gender);

    if (data.role === "radiologist") {
      const signature = dataURLToFile(finalImage, "signature.jpg");
      if (data?.certificatenumber?.trim().length > 0) {
        formData.append("licence_no", data.certificatenumber);
      }
      formData.append("file_name", data?.filename || digitalSignature[0].name);
      formData.append("image", signature);
    }

    try {
      await axios.post(`${baseURl}/auth/register`, formData);
      toastSuccess("User Registered Successfully!");
      navigate("/manageusers");
    } catch (error) {
      toastError(error.response?.data?.message || error.response?.data?.error);
    } finally {
      setLoading(false);
    }
  };

  const fetchRoles = async () => {
    try {
      const response = await axios.get(`${baseURl}/auth/roleList`);
      setRoles(response?.data?.roles?.rows);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${baseURl}/category`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });
      setCategories(response?.data?.category?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancel = () => {
    setOpen(false);
    form.setFieldsValue({ digitalSignature: [] });
  };

  const handleOk = () => {
    setOpen(false);
  };

  const handleImage = (signatureCroppedImage) => {
    setFinalImage(signatureCroppedImage);
  };

  const handlePreview = () => {
    setPreviewOpen(false);
  };

  const handleResetFields = (e) => {
    e.preventDefault();
    form.resetFields();
  };

  const imageUploadPropsHeader = {
    name: "file",
    beforeUpload: (file) => {
      return validateImageDimensions(file, 1000, 200, "Footer")
        .then(() => false)
        .catch(() => Upload.LIST_IGNORE);
    },
    headers: {
      authorization: "authorization-text",
    },
    accept: ".jpg,.jpeg,.png",
    maxCount: 1,
  };

  const imageUploadPropsFooter = {
    name: "file",
    beforeUpload: (file) => {
      return validateImageDimensions(file, 1000, 200, "Footer")
        .then(() => false)
        .catch(() => Upload.LIST_IGNORE);
    },
    headers: {
      authorization: "authorization-text",
    },
    accept: ".jpg,.jpeg,.png",
    maxCount: 1,
  };

  const validateImageDimensions = (file, maxWidth, maxHeight, label) => {
    return new Promise((resolve, reject) => {
      const isImage =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";

      if (!isImage) {
        message.error("Only .jpg, .jpeg or .png files are allowed!");
        return reject(new Error("Invalid file type")); // ❗ Use Error to fully reject
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          if (img.width > maxWidth || img.height > maxHeight) {
            message.error(
              `${label} image too large. Max allowed is ${maxWidth}px wide x ${maxHeight}px high.`
            );
            reject(new Error("Image dimensions too large")); // ❗ Use Error here too
          } else {
            resolve(false); // false = do not auto-upload
          }
        };
        img.onerror = () => {
          message.error("Invalid image file.");
          reject(new Error("Could not read image")); // ❗ Reject with error
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  };
  return (
    <div>
      <DoctorHeader />
      <Sidebar />
      <div className="page-wrapper notification_index">
        <div className="content">
          <div className="main-wrapper login-body">
            <div className="container-fluid px-0">
              <div className="row">
                <div className="col-lg-12">
                  <div className="login-wrapper">
                    <div className="loginbox">
                      <div className="login-right">
                        <div className="login-right-wrap">
                          <h2>Register User</h2>
                          <Form
                            form={form}
                            layout="vertical"
                            onFinish={onFinish}
                            initialValues={{
                              firstName: "",
                              lastName: "",
                              categoryId: "Select Category",
                              role: "Select Role",
                              email: "",
                              phone: "",
                              gender: "Select Gender",
                              age: "",
                              address: "",
                              password: "",
                              confirmPassword: "",
                            }}
                            className="row"
                          >
                            <div className="col-lg-6 col-md-6 col-12">
                              <Form.Item
                                label="First Name"
                                name="firstName"
                                rules={[
                                  {
                                    required: true,
                                    message: "First name required",
                                  },
                                ]}
                              >
                                <Input />
                              </Form.Item>
                            </div>

                            <div className="col-lg-6 col-md-6 col-12">
                              <Form.Item
                                label="Last Name"
                                name="lastName"
                                rules={[
                                  {
                                    required: true,
                                    message: "Last name required",
                                  },
                                ]}
                              >
                                <Input />
                              </Form.Item>
                            </div>

                            {!isSubAdmin && selectedRole !== "subadmin" && (
                              <div className="col-lg-6 col-md-6 col-12">
                                <Form.Item
                                  label="Category"
                                  name="categoryId"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Category is required",
                                    },
                                  ]}
                                >
                                  <Select>
                                    <Option value="Select Category" disabled>
                                      Select Category
                                    </Option>
                                    {categories?.map((element) => (
                                      <Option
                                        key={element?.id}
                                        value={element?.id}
                                      >
                                        {capitalizeEachWord(element?.name)}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </div>
                            )}

                            <div className="col-lg-6 col-md-6 col-12">
                              <Form.Item
                                label="Role"
                                name="role"
                                rules={[
                                  { required: true, message: "Role required" },
                                  {
                                    validator: (_, value) =>
                                      value === "Select Role"
                                        ? Promise.reject(
                                            "Please select a valid role"
                                          )
                                        : Promise.resolve(),
                                  },
                                ]}
                              >
                                <Select>
                                  <Option value="Select Role" disabled>
                                    Select Role
                                  </Option>
                                  {roles
                                    ?.filter(
                                      (element) =>
                                        (isSubAdmin &&
                                          element?.name !== "subadmin" &&
                                          element?.name !== "superadmin") ||
                                        (!isSubAdmin &&
                                          element?.name !== "superadmin")
                                    )
                                    ?.map((element) => (
                                      <Option
                                        key={element?.id}
                                        value={element?.name}
                                      >
                                        {getRoleName(element?.name)}
                                      </Option>
                                    ))}
                                </Select>
                              </Form.Item>
                            </div>

                            {selectedRole === "radiologist" && (
                              <div className="col-lg-6 col-md-6 col-12">
                                <Form.Item
                                  label="License/Certificate No."
                                  name="certificatenumber"
                                >
                                  <Input.TextArea />
                                </Form.Item>
                              </div>
                            )}

                            {selectedRole === "radiologist" && (
                              <div className="col-lg-6 col-md-6 col-12">
                                <Form.Item
                                  label="File Name"
                                  name="filename"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Filename is required",
                                    },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              </div>
                            )}

                            {selectedRole === "radiologist" && (
                              <div className="col-lg-6 col-md-6 col-12">
                                <Form.Item
                                  label="Digital Signature"
                                  name="digitalSignature"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Digital signature is required",
                                    },
                                  ]}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: digitalSignature.length
                                          ? "80%"
                                          : "100%",
                                      }}
                                    >
                                      <input
                                        disabled={digitalSignature.length}
                                        className="form-control"
                                        type="file"
                                        ref={fileInputRef}
                                        accept=".jpg,.jpeg,.png,.bmp,.jfif,.webp"
                                        // onClick={() => setOpen(true)}
                                        onChange={(e) => {
                                          const file = e.target.files[0];
                                          console.log("file---->", file);
                                          if (file) {
                                            form.setFieldsValue({
                                              digitalSignature: file,
                                            }); // store the actual File
                                            setSignature(file);
                                            setFinalImage(""); // reset previous cropped image
                                            setOpen(true); // open crop modal
                                          }
                                        }}
                                      />
                                    </div>
                                    {digitalSignature.length > 0 && (
                                      <div
                                        style={{
                                          justifyContent: "center",
                                          alignItems: "center",
                                          marginLeft: "20px",
                                        }}
                                      >
                                        <Button
                                          danger
                                          onClick={() => {
                                            form.setFieldsValue({
                                              digitalSignature: [],
                                            });
                                            setFinalImage("");
                                          }}
                                        >
                                          <CloseOutlined />
                                        </Button>
                                      </div>
                                    )}
                                  </div>
                                </Form.Item>

                                {finalImage && (
                                  <Button
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginTop: "10px",
                                    }}
                                    onClick={() => setPreviewOpen(true)}
                                  >
                                    Signature Preview
                                  </Button>
                                )}
                              </div>
                            )}
                            {selectedRole == "siteperson" && (
                              <>
                                <Form.Item
                                  name="header"
                                  label="Header Image (.jpg/.png)  (MAX width:1000px, height:200px)"
                                >
                                  <Upload {...imageUploadPropsHeader}>
                                    <Button icon={<UploadOutlined />}>
                                      Upload Header
                                    </Button>
                                  </Upload>
                                </Form.Item>

                                <Form.Item
                                  name="footer"
                                  label="Footer Image (.jpg/.png) (MAX width:1000px, height:200px)"
                                >
                                  <Upload {...imageUploadPropsFooter}>
                                    <Button icon={<UploadOutlined />}>
                                      Upload Footer
                                    </Button>
                                  </Upload>
                                </Form.Item>
                              </>
                            )}
                            <div className="col-lg-6 col-md-6 col-12">
                              <Form.Item
                                label="Email"
                                name="email"
                                rules={[
                                  { required: true, message: "Email required" },
                                  {
                                    type: "email",
                                    message: "Invalid email address",
                                  },
                                ]}
                              >
                                <Input />
                              </Form.Item>
                            </div>

                            <div className="col-lg-6 col-md-6 col-12">
                              <Form.Item
                                label="Phone"
                                name="phone"
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "Please enter a valid phone number",
                                  },
                                  {
                                    pattern: /^\d+$/,
                                    message:
                                      "Please enter a valid phone number",
                                  },
                                  {
                                    len: 10,
                                    message:
                                      "Phone number must be exactly 10 digits",
                                  },
                                ]}
                              >
                                <Input />
                              </Form.Item>
                            </div>

                            <div className="col-lg-6 col-md-6 col-12">
                              <Form.Item
                                label="Gender"
                                name="gender"
                                rules={[
                                  {
                                    required: true,
                                    message: "Gender Required",
                                  },
                                  {
                                    validator: (_, value) =>
                                      value === "Select Gender"
                                        ? Promise.reject("Gender Required")
                                        : Promise.resolve(),
                                  },
                                ]}
                              >
                                <Select>
                                  <Option value="Select Gender" disabled>
                                    Select Gender
                                  </Option>
                                  <Option value="male">Male</Option>
                                  <Option value="female">Female</Option>
                                </Select>
                              </Form.Item>
                            </div>

                            <div className="col-lg-6 col-md-6 col-12">
                              <Form.Item
                                label="Age"
                                name="age"
                                rules={[
                                  { required: true, message: "Age required" },
                                  {
                                    type: "number",
                                    min: 1,
                                    max: 99,
                                    message: "Age must be between 1 and 99",
                                  },
                                ]}
                              >
                                <InputNumber className="form-control" />
                              </Form.Item>
                            </div>

                            <div className="col-lg-6 col-md-6 col-12">
                              <Form.Item
                                label="Address"
                                name="address"
                                rules={[
                                  {
                                    required: true,
                                    message: "Address required",
                                  },
                                ]}
                              >
                                <Input />
                              </Form.Item>
                            </div>

                            <div className="col-lg-6 col-md-6 col-12">
                              <Form.Item
                                label="Password"
                                name="password"
                                rules={[
                                  {
                                    required: true,
                                    message: "Password is required",
                                  },
                                  {
                                    min: 8,
                                    max: 12,
                                    message: "Password must be 8-12 characters",
                                  },
                                  {
                                    pattern: /[a-zA-Z]/,
                                    message:
                                      "Password must contain at least one letter",
                                  },
                                  {
                                    pattern: /[0-9]/,
                                    message:
                                      "Password must contain at least one number",
                                  },
                                  {
                                    pattern: /[!@#$%^&*(),.?":{}|<>]/,
                                    message:
                                      "Password must contain at least one special character",
                                  },
                                ]}
                              >
                                <Input.Password
                                  type={passwordVisible ? "text" : "password"}
                                  visibilityToggle={{
                                    visible: passwordVisible,
                                    onVisibleChange: setPasswordVisible,
                                  }}
                                  iconRender={(visible) =>
                                    visible ? (
                                      <EyeOff className="react-feather-custom" />
                                    ) : (
                                      <Eye className="react-feather-custom" />
                                    )
                                  }
                                />
                              </Form.Item>
                            </div>

                            <div className="col-lg-6 col-md-6 col-12">
                              <Form.Item
                                label="Confirm Password"
                                name="confirmPassword"
                                dependencies={["password"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please confirm your password",
                                  },
                                  ({ getFieldValue }) => ({
                                    validator(_, value) {
                                      if (
                                        !value ||
                                        getFieldValue("password") === value
                                      ) {
                                        return Promise.resolve();
                                      }
                                      return Promise.reject(
                                        "Passwords must match"
                                      );
                                    },
                                  }),
                                ]}
                              >
                                <Input.Password
                                  type={passwordVisible1 ? "text" : "password"}
                                  visibilityToggle={{
                                    visible: passwordVisible1,
                                    onVisibleChange: setPasswordVisible1,
                                  }}
                                  iconRender={(visible) =>
                                    visible ? (
                                      <EyeOff className="react-feather-custom" />
                                    ) : (
                                      <Eye className="react-feather-custom" />
                                    )
                                  }
                                />
                              </Form.Item>
                            </div>

                            <div className="form-group login-btn d-flex gap-5 justify-content-center  mt-5 ">
                              <Button
                                loading={loading}
                                type="primary"
                                htmlType="submit"
                                className="btn btn-primary btn-block w-25"
                              >
                                Register
                              </Button>

                              <Button
                                className="btn btn-secondary reset_button btn-block w-25"
                                onClick={handleResetFields}
                              >
                                Reset
                              </Button>
                            </div>
                          </Form>
                        </div>

                        <Modal
                          title="Edit Signature"
                          open={open && digitalSignature?.length > 0}
                          onCancel={handleCancel}
                          onOk={handleOk}
                          okText="Submit"
                          destroyOnClose
                        >
                          {digitalSignature?.length > 0 && (
                            <SignatureCrop
                              imgSrc={signature}
                              handleImage={handleImage}
                            />
                          )}
                        </Modal>

                        <Modal
                          title="Signature Preview"
                          open={previewOpen}
                          onCancel={handlePreview}
                          footer={null}
                          destroyOnClose
                        >
                          <img
                            src={finalImage}
                            alt="signature"
                            style={{
                              maxWidth: "100%",
                              marginTop: "10px",
                            }}
                          />
                        </Modal>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
